export const getQueryParams = (): Record<string, unknown> => {
  return Object.fromEntries(new URLSearchParams(window.location.search))
}

export const getQueryParamsFromString = (urlLikeString: string): Record<string, unknown> => {
  return Object.fromEntries(new URLSearchParams(urlLikeString.split('?')[1]))
}

export const getAdditionalQueryParameters = (): Record<string, unknown> => {
  const queryParams = getQueryParams()

  const parameterI = queryParams.i as string
  const parameterP = queryParams.p as string
  const parameterL = queryParams.l as string
  const parameterC = queryParams.c as string
  const parameterF = queryParams.f as string

  return {
    i: parameterI,
    p: parameterP,
    l: parameterL,
    c: parameterC,
    f: parameterF,
  }
}
